import React from "react";

import { gql } from "@apollo/client";
import { Mutation } from "@apollo/client/react/components";

import { OrderObject } from "./../Queries/OrderQuery";
import orderFragments from "./../Queries/graphql/orderFragments";
import orderEventFragments from "./../Queries/graphql/orderEventFragments";
import orderLineFragments from "./../Queries/graphql/orderLineFragments";

import CompleteOrderBtn from "./CompleteOrderBtn";

const COMPLETE_ORDER = gql`
  mutation completeOrder($id: ID!) {
    completeOrder(id: $id) {
      order {
        ...OrderFields
        events {
          ...EventQuery
        }
        orderLines {
          ...OrderLineQuery
        }
      }
      errors {
        path
        message
      }
    }
  }
  ${orderFragments.query}
  ${orderEventFragments.query}
  ${orderLineFragments.query}
`;

class CompleteOrder extends React.Component {
  state = { errors: null };
  render() {
    const { order } = this.props;
    return (
      <Mutation mutation={COMPLETE_ORDER} onError={this.onError}>
        {(update, { loading, error }) => (
          <CompleteOrderBtn order={order} update={update} />
        )}
      </Mutation>
    );
  }

  onError = error => {
    console.log("onError occurred");
    console.log(error);
  };
}

CompleteOrder.propTypes = {
  order: OrderObject.isRequired
};

export default CompleteOrder;
